/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Permission
 * @export
 * @interface Permission
 */
export interface Permission {
    /**
     * institute uuid of the permissions
     * @type {string}
     * @memberof Permission
     */
    instituteUuid?: string;
    /**
     * name of the permissions
     * @type {string}
     * @memberof Permission
     */
    name?: string;
    /**
     * tell if the permission is active or not
     * @type {boolean}
     * @memberof Permission
     */
    active?: boolean;
}

/**
 * Check if a given object implements the Permission interface.
 */
export function instanceOfPermission(value: object): value is Permission {
    return true;
}

export function PermissionFromJSON(json: any): Permission {
    return PermissionFromJSONTyped(json, false);
}

export function PermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Permission {
    if (json == null) {
        return json;
    }
    return {
        
        'instituteUuid': json['instituteUuid'] == null ? undefined : json['instituteUuid'],
        'name': json['name'] == null ? undefined : json['name'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function PermissionToJSON(json: any): Permission {
    return PermissionToJSONTyped(json, false);
}

export function PermissionToJSONTyped(value?: Permission | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instituteUuid': value['instituteUuid'],
        'name': value['name'],
        'active': value['active'],
    };
}

